<template>
    <div>
        <el-table
                :data="firstData"
                border
                stripe
                style="width: 100%"
                :default-sort="{prop: 'timestamp', order: 'descending'}"
        >
            <el-table-column
                    property="rowindex"
                    label="序号"
                    width="60px"
            >
            </el-table-column>
            <el-table-column
                    property="store_name"
                    label="门店"
                    sortable
                    min-width="210"
            >
            </el-table-column>

            <el-table-column
                    property="address"
                    label="地址"
                    sortable
                    min-width="210"
            >
            </el-table-column>

            <el-table-column
                    property="title"
                    label="标题"
                    sortable
                    min-width="210"
            >
            </el-table-column>
            <el-table-column
                    property="status"
                    label="状态"
                    sortable
                    min-width="210"
            >
                <template slot-scope="scope">
                    <span v-if="scope.row.status=='NEW'"
                    >尚未派单</span>
                    <span v-else-if="scope.row.status=='AWAIT'"
                    >尚未下单</span>

                </template>
            </el-table-column>
            <el-table-column
                    fixed="right" label="操作"
                    width="80"
            >
                <template slot-scope="scope">
                    <el-button
                            type="warning" size="small"
                            @click="info(scope.$index, scope.row)">详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import http from '../../../APIService/http'

    export default {
        props: {
//            firstData: {
//                type: Array,
//                default: () => []
//            },
        },
        components: {
        },
        data() {
            return {
                firstData : [],
            }
        },
        computed: {},
        created() {
        },
        methods: {
            getData(data) {
                this.firstData = data
            },
            info(index, row) {
                this.$router.push({
                    path: '/workOrderInfo',
                    query: {
                        ticket_id: row.ticket_id,
                        store_name: row.store_name,
                        address: row.address
                    }
                })
            },


        }
    }
</script>

<style lang="scss" module>
    @import '../../../assets/css/default';


</style>



// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/tableList/firstTable.vue